import React from "react";
import { List, ListItem, Stack, Text } from "@origin-digital/ods-core";
import { FeeInfo, FeeScriptingEnum } from "./types";
import { generateFeeText } from "./feeUtils";

const RemoveSupplyPublicAgreementGas = ({
  feeInfo,
}: {
  feeInfo: FeeInfo | null;
}) => {
  return (
    <Stack space="medium">
      <Text>
        By clicking Accept and submit, you understand and agree that :
      </Text>
      <List space="medium">
        <ListItem>
          All the information you have provided above is accurate.
        </ListItem>
        <ListItem>
          You consent to the permanent disconnection and removal of your supply.
          Origin will send confirmation when this is completed.
        </ListItem>
        <ListItem>
          Origin will, as per your request, arrange for the Distributor and/or
          Metering Provider to permanently disconnect the gas supply and meter
          at the above address.
        </ListItem>
        <ListItem>
          Distributors and/or Metering Providers may charge fees for removing
          their gas supply and meter. If they charge Origin, we will pass the
          fees onto you, the account holder
        </ListItem>
        {(!feeInfo || feeInfo.feeScripting !== FeeScriptingEnum.NO_FEE) && (
          <ListItem>
            {feeInfo
              ? generateFeeText(feeInfo, "gas")
              : "Fee information will be provided once available."}
          </ListItem>
        )}
        <ListItem>
          You will pay Origin the fees from the distributor and/or metering
          provider in accordance with the bill we issue to you for these fees.
        </ListItem>
        <ListItem>
          Please note that if you choose to have natural gas connected at a
          later date, connection fees may apply.
        </ListItem>
      </List>
    </Stack>
  );
};
export default RemoveSupplyPublicAgreementGas;
